import { ViewportContext } from '@/context/ViewportContext';
import { useContext } from 'react';

export const useViewportContext = () => useContext(ViewportContext);
